import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="font-display text-2xl font-semibold tracking-tight">GK Fleet</Link>
            <p className="mt-4 text-[#9CA3AF] max-w-md leading-relaxed">
              {COMPANY.secondary_message} Headquartered in Hyderabad, GK Fleet builds professionally managed vehicles for ambitious drivers across India's mobility platforms.
            </p>
            <div className="mt-8 space-y-3 text-sm text-[#D1D5DB]">
              <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#3B82F6]" /> {COMPANY.phone}</div>
              <div className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#3B82F6]" /> {COMPANY.email}</div>
              <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#3B82F6]" /> {COMPANY.hq}</div>
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-[#9CA3AF] mb-4">Company</p>
            <ul className="space-y-2 text-sm">
              <li><Link className="text-[#D1D5DB] hover:text-white" to="/investors">Investors</Link></li>
              <li><Link className="text-[#D1D5DB] hover:text-white" to="/careers">Careers</Link></li>
              <li><Link className="text-[#D1D5DB] hover:text-white" to="/blog">Blog</Link></li>
              <li><Link className="text-[#D1D5DB] hover:text-white" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-[#9CA3AF] mb-4">Drivers</p>
            <ul className="space-y-2 text-sm">
              <li><Link className="text-[#D1D5DB] hover:text-white" to="/drivers">Driver Program</Link></li>
              <li><Link className="text-[#D1D5DB] hover:text-white" to="/dashboard">Fleet Dashboard</Link></li>
              <li>
                <a className="text-[#D1D5DB] hover:text-white" href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer">WhatsApp</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-[#9CA3AF] mb-4">Founder</p>
            <p className="text-white font-medium">{COMPANY.founder}</p>
            <p className="mt-1 text-sm text-[#9CA3AF]">Founder & Director</p>
            <p className="mt-6 text-xs tracking-[0.2em] uppercase text-[#9CA3AF] mb-2">Admin</p>
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-sm text-[#D1D5DB] hover:text-white">Admin Login →</Link>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-white/10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
          <p className="text-xs text-[#9CA3AF]">© {new Date().getFullYear()} GK Fleet Private Limited. All rights reserved.</p>
          <p className="text-xs text-[#9CA3AF]">gkfleet.in · Hyderabad, India</p>
        </div>
      </div>

      <div aria-hidden className="select-none pointer-events-none absolute -bottom-16 left-0 right-0 text-center font-display font-bold text-[26vw] leading-none tracking-tighter text-white/[0.03]">
        GKFLEET
      </div>
    </footer>
  );
}
